import RMSDashboardContainer from "./RMSDashboardContainer";
import RMSDashboardStore from "./RMSDashboardStore";

export default RMSDashboardStore(RMSDashboardContainer);